import React from 'react';
import { RoutePaths } from '../../../Constants/Common';
import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react';
import LoadingContainer from '../loadingContainer/LoadingContainer';
import { t } from 'i18next';

type AuthenticationGuardProps = {
    component: React.ComponentType;
    path: string;
};

export const AuthenticationGuard = ({
    component,
    path
}: AuthenticationGuardProps) => {
    const { user } = useAuth0();
    const userIsVerified = user && user.email_verified === true;
    const returnPath = userIsVerified ? path : RoutePaths.Redirect;

    const Component = withAuthenticationRequired(component, {
        returnTo: returnPath,
        onRedirecting: () => (
            <LoadingContainer message={t('Redirecting....')} loading={true} />
        )
    });

    return <Component />;
};

export default AuthenticationGuard;
